/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/finish': {
    width: 13,
    height: 16,
    viewBox: '0 0 13 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.6 2.4a5.797 5.797 0 10-8.2 8.2l3.735 3.733a.517.517 0 00.73 0L10.6 10.6a5.797 5.797 0 000-8.198zm-8.696-.496a6.5 6.5 0 119.192 9.192L7.362 14.83a1.22 1.22 0 01-1.724 0l-3.734-3.734a6.5 6.5 0 010-9.192z" _fill="#E25046"/><path pid="1" d="M10.191 6.501a3.69 3.69 0 11-7.378 0 3.69 3.69 0 017.378 0z" _fill="#E25046"/>'
  }
})
